import React, { useState } from 'react';
import { defaultValues } from '.././DiagnosticB/DefaultValue';
import { useForm, FormProvider } from 'react-hook-form';
import styles from './Styles/DiagnosticBPage.module.css';
import { toast } from 'react-toastify';
import preguntas from './ComponentsDiagnosticB/Questions';
import EndOfDiagnostic from './ComponentsDiagnosticB/EndOfDiagnostic';
import { db } from '../../firebaseConfig';
import { getSearchParams } from '../../utilities/getSearchParams';
import { doc, serverTimestamp, setDoc } from 'firebase/firestore';
import { v4 as uuidv4 } from 'uuid';
import { isArray } from 'lodash';
import { useDiagnostico } from '../../context/DiagnosticoContext/DiagnosticoHook';
import { FarewellDiagnosis } from './ComponentsDiagnosticB/FarewellDiagnosis';
const DiagnosticBPage = () => {
  const {
    navigation: { endOfDiagnostic },
    setInfoForm,
    formDataInputsDiagnosticB,
    idQuestionsFn,
  } = useDiagnostico();
  const { ...formMethods } = useForm({
    defaultValues: {
      secciones: defaultValues,
      chatRadarImg: '',
      chatMeasurerImg: '',
    },
  });

  const [indiceSeccionActual, setIndiceSeccionActual] = useState(0);
  const seccionActual = preguntas.secciones[indiceSeccionActual];
  const [diagnosticoFinalizado, setDiagnosticoFinalizado] = useState(false);
  const [respuestaOtro, setRespuestaOtro] = useState({});
  const [respuestas, setRespuestas] = useState({});

  // Utilidad para validar correos electrónicos
  const validarEmail = (email) => {
    // Esta es una expresión regular simple para validar emails.
    // Puedes ajustarla según tus necesidades.
    const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/gi;
    return re.test(String(email).toLowerCase());
  };

  const validarSeccionActual = () => {
    const seccionesForm = formMethods.getValues('secciones');

    if (!seccionActual || !seccionActual.idSeccion) {
      return false;
    }

    // Verifica que la sección a validar exista en el formulario
    if (!seccionesForm || !seccionesForm[seccionActual.idSeccion]) {
      return false; // No puedes validar una sección indefinida.
    }

    const preguntasDeSeccion = Object.entries(
      seccionesForm[seccionActual.idSeccion],
    );

    for (let [idPregunta, pregunta] of preguntasDeSeccion) {
      if (Array.isArray(pregunta.text)) {
        // Si 'text' es un array, asegúrate de que no esté vacío.
        if (pregunta.text.length === 0) {
          return false; // Array vacío, validación fallida.
        }
      } else {
        // Si 'text' es una cadena, asegúrate de que no esté vacía.
        if (pregunta.text.trim() === '') {
          return false; // Cadena vacía, validación fallida.
        }
      }
      // Validación específica para la pregunta de email en la primera sección.
      if (seccionActual.idSeccion === 'sec1' && idPregunta === 'preg7') {
        if (!validarEmail(pregunta.text)) {
          return 'correo invalido'; // Email no válido.
        }
      }

      if (seccionActual.idSeccion === 'sec1' && idPregunta === 'preg6') {
        const limiteCaracteres = 700;
        if (pregunta.text.length > limiteCaracteres) {
          return 'respuesta larga';
        }
      }
    }
    return true; // Todos los campos son válidos.
  };

  const avanzarSeccion = async () => {
    const validate = validarSeccionActual();

    if (!validate) {
      toast.error('uno o mas campos estan vacios.');
      return;
    }
    if (validate === 'correo invalido') {
      toast.error('correo invalido');
      return;
    }

    if (validate === 'respuesta larga') {
      toast.error(
        'Descripción de la empresa demasiada larga y excede el limite de 700 caracteres.',
      );
      return;
    }

    if (indiceSeccionActual < preguntas.secciones.length - 1) {
      // Solo avanza a la siguiente sección.
      setIndiceSeccionActual(indiceSeccionActual + 1);
    } else {
      // Al finalizar el formulario, integra las respuestas de "Otro"
      const respuestasFinales = Object.entries(respuestas).reduce(
        (acc, [key, value]) => {
          acc[key] = value;
          if (value.includes('Otro')) {
            // Reemplaza el valor 'Otro' por el texto especificado por el usuario, si existe.
            const respuestaEspecifica = respuestaOtro[key]?.trim();
            acc[key] = respuestaEspecifica ? respuestaEspecifica : value;
          }
          return acc;
        },
        {},
      );

      // Envía las respuestas finales a Firestore
      enviarRespuestasAFirestore(respuestasFinales);
      setDiagnosticoFinalizado(true); // Marcar el diagnóstico como finalizado
    }
  };

  const handleMultipleOptionChange = (e, idPregunta, seccionActualIndex) => {
    /***************Logica nueva ****************************/
    const { value, checked } = e.target;
    if (checked) {
      const option = formMethods.getValues(
        `secciones.${[seccionActualIndex]}.${[idPregunta]}.text`,
      );
      if (isArray(option)) {
        formMethods.setValue(
          `secciones.${[seccionActualIndex]}.${[idPregunta]}`,
          {
            text: [...option, value],
            value: 'multiple',
          },
        );
      } else {
        formMethods.setValue(
          `secciones.${[seccionActualIndex]}.${[idPregunta]}`,
          {
            text: [value],
            value: 'multiple',
          },
        );
      }
    } else {
      const option = formMethods.getValues(
        `secciones.${[seccionActualIndex]}.${[idPregunta]}.text`,
      );
      if (isArray(option)) {
        formMethods.setValue(
          `secciones.${[seccionActualIndex]}.${[idPregunta]}`,
          {
            text: option.filter((item) => item !== value),
            value: 'multiple',
          },
        );
      } else {
        formMethods.setValue(
          `secciones.${[seccionActualIndex]}.${[idPregunta]}`,
          {
            text: [],
            value: 'multiple',
          },
        );
      }
    }
    /******************************************************** */

    // Si es "Otro", maneja la entrada de texto asociada
    if (value === 'Otro') {
      setRespuestaOtro((prev) => ({
        ...prev,
        [idPregunta]: checked ? prev[idPregunta] || '' : '',
      }));
    }

    setRespuestas((prev) => {
      const prevRespuestas = prev[idPregunta] || [];
      const newRespuestas = checked
        ? [...prevRespuestas, value] // Añade la opción seleccionada
        : prevRespuestas.filter((item) => item !== value); // Elimina la opción deseleccionada

      // Si "Otro" es deseleccionado, asegúrate de eliminar también el texto ingresado
      if (value === 'Otro' && !checked) {
        const { [idPregunta]: textValue, ...restOtro } = respuestaOtro;
        setRespuestaOtro(restOtro);
        return {
          ...prev,
          [idPregunta]: newRespuestas.filter((item) => item !== 'Otro'),
        };
      }

      return { ...prev, [idPregunta]: newRespuestas };
    });
  };

  const handleMultipleOptionLibreChange = (
    e,
    idPregunta,
    seccionActualIndex,
  ) => {
    const textoIngresado = e.target.value;

    // Actualiza el estado local para la respuesta específica de "Otro".
    setRespuestaOtro((prevRespuestaOtro) => ({
      ...prevRespuestaOtro,
      [idPregunta]: textoIngresado,
    }));

    // Obtiene el valor actual del campo en el formulario.
    const currentValue = formMethods.getValues(
      `secciones.${seccionActualIndex}.${idPregunta}.text`,
    );

    // Encuentra el índice de "Otro" en el array de respuestas.
    const indexOtro = currentValue.findIndex(
      (item) => item === 'Otro' || item.startsWith('Otro:'),
    );

    if (indexOtro !== -1) {
      // Actualiza el valor de "Otro" en el array con el nuevo texto ingresado.
      currentValue[indexOtro] = `Otro: ${textoIngresado}`;
    } else {
      // Esto se incluye para completitud, pero en este contexto, siempre deberíamos tener "Otro" en el array.
      currentValue.push(`Otro: ${textoIngresado}`);
    }
    // Actualiza el valor en react-hook-form.
    formMethods.setValue(
      `secciones.${seccionActualIndex}.${idPregunta}.text`,
      currentValue,
    );
  };

  const otroTextfield = async (
    e,
    seccionActualIndex,
    indexPregunta,
    enunciado,
  ) => {
    const { value } = e.target;
    formMethods.setValue(
      `secciones.${[seccionActualIndex]}.${[indexPregunta]}`,
      {
        titulo: enunciado,
        text: value,
        value: '',
      },
    );
    setRespuestaOtro((prev) => ({
      ...prev,
      [indexPregunta]: value,
    }));

    // Asegúrate de actualizar también el estado 'respuestas' para reflejar el valor de "Otro"
    setRespuestas((prev) => ({
      ...prev,
      [indexPregunta]: 'Otro: ' + value, // Concatena 'Otro' con el valor específico ingresado
    }));
  };

  // // Actualiza las respuestas múltiples incluyendo o excluyendo la opción marcada.
  // setRespuestas(prev => {
  //   const prevRespuestas = prev[idPregunta] || [];
  //   return {
  //     ...prev,
  //     [idPregunta]: checked
  //       ? [...prevRespuestas, value]
  //       : prevRespuestas.filter(item => item !== value),
  //   };
  // });

  const handleLibreChange = (
    e,
    seccionActualIndex,
    indexPregunta,
    enunciado,
  ) => {
    const { value } = e.target;
    formMethods.setValue(
      `secciones.${[seccionActualIndex]}.${[indexPregunta]}`,
      {
        titulo: enunciado,
        text: value,
        value: '',
      },
    );
    setRespuestas((prev) => ({
      ...prev,
      [indexPregunta]: value, // Asegúrate de que esta línea refleje correctamente cómo quieres almacenar las respuestas
    }));
  };

  const handleOptionChange = (
    e,
    idPregunta,
    enunciado,
    seccionActualIndex,
    valorPromedio,
  ) => {
    const { value } = e.target;

    if (value !== 'Otro') {
      // Guarda la respuesta seleccionada y asegúrate de eliminar "Otro" si estaba seleccionado.
      setRespuestas((prev) => ({ ...prev, [idPregunta]: value }));
      if (idPregunta in respuestaOtro) {
        setRespuestaOtro((prev) => {
          const { [idPregunta]: omit, ...rest } = prev;
          return rest;
        });
      }
    } else {
      // Si se selecciona "Otro", guarda "Otro" como valor y espera a que el usuario escriba su respuesta.
      setRespuestas((prev) => ({ ...prev, [idPregunta]: 'Otro' }));
      // Asegúrate de que haya un espacio para la entrada personalizada del usuario.
      setRespuestaOtro((prev) => ({
        ...prev,
        [idPregunta]: prev[idPregunta] || '',
      }));
    }
    formMethods.setValue(`secciones.${[seccionActualIndex]}.${[idPregunta]}`, {
      titulo: enunciado,
      text: value,
      value: valorPromedio ?? '',
    });
  };
  const enviarRespuestasAFirestore = async () => {
    const { id_key } = getSearchParams();
    // Genera un ID único para este conjunto de respuestas
    const idDiagnostico = uuidv4();
    const idQuestion = uuidv4();
    // Combina las respuestas múltiples con "Otro" si es necesario
    const respuestasParaEnviar = Object.keys(respuestas).reduce((acc, key) => {
      const esMultipleOpcion = Array.isArray(respuestas[key]);
      const tieneOtro = esMultipleOpcion && respuestas[key].includes('Otro');

      if (tieneOtro) {
        // Reemplaza "Otro" por el texto ingresado o lo mantiene si no hay texto adicional
        const respuestasSinOtro = respuestas[key].filter(
          (item) => item !== 'Otro',
        );
        const respuestaDeOtro = respuestaOtro[key]?.trim() || 'Otro';
        acc[key] = [...respuestasSinOtro, respuestaDeOtro];
      } else {
        acc[key] = respuestas[key];
      }

      return acc;
    }, {});

    // Referencia al documento donde se almacenarán las respuestas
    const docRef = doc(db, 'respuestasMadurezDigital', idQuestion);
    try {
      // Envío de las respuestas al documento en Firestore
      await setDoc(docRef, {
        idDiagnostico,
        timestamp: serverTimestamp(),
        respuestas: respuestasParaEnviar,
        idToken: id_key ?? '',
      });
      idQuestionsFn(idQuestion);
    } catch (error) {
      console.error('Error al enviar respuestas a Firestore:', error);
    }
  };

  if (endOfDiagnostic) {
    return <FarewellDiagnosis />;
  }

  if (diagnosticoFinalizado) {
    return (
      <FormProvider {...formMethods}>
        <div className={styles.container}>
          <EndOfDiagnostic />
        </div>
      </FormProvider>
    );
  }

  const atras = () => {
    setIndiceSeccionActual((indiceActual) => Math.max(indiceActual - 1, 0));
  };

  return (
    <div className={styles.container}>
      <h2>{seccionActual.tituloSeccion}</h2>
      {seccionActual.preguntas.map((pregunta, index) => {
        if (pregunta.idPregunta === 'preg7') {
          return (
            <div className={styles.containerStatement} key={index}>
              <p className={styles.enunciado}>{pregunta.enunciado}</p>
              <input
                value={formDataInputsDiagnosticB?.email || ''}
                type="email"
                onChange={(e) => {
                  handleLibreChange(
                    e,
                    seccionActual.idSeccion,
                    pregunta.idPregunta,
                    pregunta.enunciado,
                  );
                  setInfoForm({ value: e.target.value, input: 'email' });
                }}
              />
            </div>
          );
        } else {
          return (
            <div
              className={styles.containerStatement}
              key={`${index}_${pregunta.idPregunta}`}
              id={`${index}_${pregunta.idPregunta}`}
            >
              <p className={styles.enunciado}>{pregunta.enunciado}</p>
              {pregunta.tipo === 'libre' && (
                <input
                  value={respuestas[pregunta.idPregunta] || ''}
                  type="text"
                  onChange={(e) =>
                    handleLibreChange(
                      e,
                      seccionActual.idSeccion,
                      pregunta.idPregunta,
                      pregunta.enunciado,
                    )
                  }
                />
              )}
              {pregunta.tipo === 'unica opcion' &&
                pregunta.opciones.map((opcion, idx) => (
                  <div key={idx}>
                    <div className={styles.radioButtonContainer}>
                      <input
                        className={styles.radioButtons}
                        type="radio"
                        id={`${pregunta.idPregunta}-${idx}`}
                        name={pregunta.idPregunta}
                        value={opcion.etiqueta}
                        checked={
                          respuestas[pregunta.idPregunta] === opcion.etiqueta
                        }
                        onChange={(e) =>
                          handleOptionChange(
                            e,
                            pregunta.idPregunta,
                            pregunta.enunciado,
                            seccionActual.idSeccion,
                            opcion.valor,
                          )
                        }
                      />
                      <label htmlFor={`${pregunta.idPregunta}-${idx}`}>
                        {opcion.etiqueta}
                      </label>
                    </div>

                    {opcion.etiqueta === 'Otro' &&
                      respuestaOtro[pregunta.idPregunta] !== undefined && (
                        <input
                          type="text"
                          placeholder="¿Cuál?"
                          // value={respuestaOtro[pregunta.idPregunta] || ''}
                          onChange={(e) =>
                            otroTextfield(
                              e,
                              seccionActual.idSeccion,
                              pregunta.idPregunta,
                              pregunta.enunciado,
                            )
                          }
                        />
                      )}
                  </div>
                ))}
              {pregunta.tipo === 'multiple opcion' &&
                pregunta.opciones.map((opcion, idx) => (
                  <div className={styles.customCheckbox} key={idx}>
                    <input
                      type="checkbox"
                      id={`${pregunta.idPregunta}-${idx}`}
                      name={pregunta.idPregunta}
                      value={opcion.etiqueta}
                      onChange={(e) =>
                        handleMultipleOptionChange(
                          e,
                          pregunta.idPregunta,
                          seccionActual.idSeccion,
                        )
                      }
                      checked={respuestas[pregunta.idPregunta]?.includes(
                        opcion.etiqueta,
                      )}
                    />
                    <label htmlFor={`${pregunta.idPregunta}-${idx}`}>
                      {opcion.etiqueta}
                    </label>
                    {opcion.etiqueta === 'Otro' &&
                      respuestas[pregunta.idPregunta]?.includes('Otro') && (
                        <input
                          type="text"
                          placeholder="¿Cuál?"
                          //value={respuestaOtro[pregunta.idPregunta] || ''}
                          onChange={(e) =>
                            handleMultipleOptionLibreChange(
                              e,
                              pregunta.idPregunta,
                              seccionActual.idSeccion,
                            )
                          }
                        />
                      )}
                  </div>
                ))}
            </div>
          );
        }
      })}

      <div className="botones-contenedor-FormB">
        {indiceSeccionActual > 0 && (
          <div>
            <button className={`btn btn-back btn-comenzar`} onClick={atras}>
              <span className="material-icons">arrow_back</span>
              {'Atrás'}
            </button>
          </div>
        )}

        <div>
          <button
            className="btn btn-primary btn-comenzar"
            onClick={avanzarSeccion}
          >
            Siguiente
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiagnosticBPage;
